"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[731],{

/***/ 33859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ej": function() { return /* binding */ FlexContainer; },
/* harmony export */   "Hz": function() { return /* binding */ FlexRight; },
/* harmony export */   "M9": function() { return /* binding */ FlexLeft; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37536);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0;\n  display: flex;\n  flex-direction: column;\n  margin: auto 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  margin-left: 1rem;\n  width: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var FlexContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2cc1d5c6-0"
})(_templateObject());
var FlexLeft = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2cc1d5c6-1"
})(_templateObject1());
var FlexRight = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2cc1d5c6-2"
})(_templateObject2());


/***/ }),

/***/ 74982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Toggle; }
/* harmony export */ });
/* unused harmony export ToggleBase */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60822);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37536);
/* harmony import */ var react_toggle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93897);
/* harmony import */ var react_toggle_style_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11617);
/* harmony import */ var react_toggle_style_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_toggle_style_css__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n\n  &.react-toggle-custom {\n    & > .react-toggle-track {\n      background-color: #9c3434;\n    }\n\n    &.react-toggle--checked > .react-toggle-track {\n      background-color: #459f25;\n    }\n\n    &:hover {\n      & > .react-toggle-track {\n        background-color: #b95353;\n      }\n\n      &.react-toggle--checked > .react-toggle-track {\n        background-color: #5db240;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ToggleBase = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_toggle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2eb25614-0"
})(_templateObject());
function Toggle(_param) {
    var identifier = _param.identifier, className = _param.className, onCheckedChanged = _param.onCheckedChanged, children = _param.children, props = _objectWithoutProperties(_param, [
        "identifier",
        "className",
        "onCheckedChanged",
        "children"
    ]);
    var onChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        onCheckedChanged(e.target.checked);
    }, [
        onCheckedChanged
    ]);
    var Result = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ToggleBase, _objectSpread({
        id: identifier,
        className: className,
        onChange: onChange
    }, props));
    if (children) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            htmlFor: identifier,
            className: "d-flex m-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "mr-2",
                    children: Result
                }),
                children
            ]
        });
    }
    return Result;
}


/***/ }),

/***/ 4905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GB": function() { return /* binding */ FilePicker; }
});

// UNUSED EXPORTS: FilePickerBody, FilePickerContainer, FilePickerHeader, FilePickerTitle, TabsPanelStyled

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28354);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(60822);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(37536);
// EXTERNAL MODULE: ./src/helpers/useTranslationSafe.ts
var useTranslationSafe = __webpack_require__(87181);
// EXTERNAL MODULE: ./src/io/AlgorithmInput.ts + 3 modules
var AlgorithmInput = __webpack_require__(75583);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/TabContent.js
var TabContent = __webpack_require__(36996);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/TabPane.js
var TabPane = __webpack_require__(45679);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Nav.js
var Nav = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/NavItem.js
var NavItem = __webpack_require__(55097);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/NavLink.js
var NavLink = __webpack_require__(75740);
;// CONCATENATED MODULE: ./src/components/Common/TabsLight.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var TabsPanelContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c4cb6ef-0"
})(_templateObject());
var TabsLight_TabContent = (0,styled_components_browser_esm/* default */.ZP)(TabContent/* default */.Z).withConfig({
    componentId: "sc-3c4cb6ef-1"
})(_templateObject1());
var TabsLight_TabPane = (0,styled_components_browser_esm/* default */.ZP)(TabPane/* default */.Z).withConfig({
    componentId: "sc-3c4cb6ef-2"
})(_templateObject2());
var TabsLight_Nav = (0,styled_components_browser_esm/* default */.ZP)(Nav/* default */.Z).withConfig({
    componentId: "sc-3c4cb6ef-3"
})(_templateObject3());
function TabsLight(param) {
    var tabs = param.tabs;
    var ref = useState("file"), activeTab = ref[0], setActiveTab = ref[1];
    return /*#__PURE__*/ _jsxs(TabsPanelContainer, {
        children: [
            /*#__PURE__*/ _jsx(TabsPanel, {
                tabs: tabs,
                activeTab: activeTab,
                onChange: setActiveTab
            }),
            /*#__PURE__*/ _jsx(TabsContent, {
                tabs: tabs,
                activeTab: activeTab
            })
        ]
    });
}
function TabComponent(_param) {
    var tab = _param.tab, activeTab = _param.activeTab, onChange = _param.onChange, disabled = _param.disabled, props = _objectWithoutProperties(_param, [
        "tab",
        "activeTab",
        "onChange",
        "disabled"
    ]);
    var onClick = (0,react.useCallback)(function() {
        if (activeTab !== tab.name) {
            onChange(tab.name);
        }
    }, [
        activeTab,
        onChange,
        tab.name
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.Z, _objectSpread({
            active: !disabled && activeTab === tab.name,
            onClick: onClick,
            disabled: disabled
        }, props, {
            children: tab.title
        }))
    });
}
function TabsPanel(_param) {
    var tabs = _param.tabs, activeTab = _param.activeTab, onChange = _param.onChange, disabled = _param.disabled, restProps = _objectWithoutProperties(_param, [
        "tabs",
        "activeTab",
        "onChange",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLight_Nav, _objectSpread({
        tabs: true
    }, restProps, {
        children: tabs.map(function(tab) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabComponent, {
                tab: tab,
                activeTab: activeTab,
                onChange: onChange,
                disabled: disabled
            }, tab.name);
        })
    }));
}
function TabsContent(_param) {
    var tabs = _param.tabs, activeTab = _param.activeTab, props = _objectWithoutProperties(_param, [
        "tabs",
        "activeTab"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLight_TabContent, _objectSpread({
        activeTab: activeTab
    }, props, {
        children: tabs.map(function(tab) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLight_TabPane, {
                tabId: tab.name,
                children: tab.body
            }, tab.name);
        })
    }));
}

// EXTERNAL MODULE: ./node_modules/reactstrap/es/Form.js
var Form = __webpack_require__(67693);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/FormGroup.js
var FormGroup = __webpack_require__(16082);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Label.js
var Label = __webpack_require__(15605);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Row.js
var Row = __webpack_require__(19343);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Col.js
var Col = __webpack_require__(70146);
;// CONCATENATED MODULE: ./src/components/FilePicker/FilePickerStyles.tsx
function FilePickerStyles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FilePickerStyles_templateObject() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  margin: 0 5px;\n"
    ]);
    FilePickerStyles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilePickerStyles_templateObject1() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin: 0 !important;\n"
    ]);
    FilePickerStyles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FilePickerStyles_templateObject2() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        "\n  margin-right: auto;\n  margin-left: 4px;\n  margin-bottom: 2px;\n"
    ]);
    FilePickerStyles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FilePickerStyles_templateObject3() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        "\n  margin-left: auto;\n  font-size: 0.75rem;\n  color: ",
        ";\n"
    ]);
    FilePickerStyles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  margin-top: 5px;\n  margin-bottom: 3px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        "\n  margin-right: auto;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = FilePickerStyles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin: auto;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var FilePickerStyles_Form = (0,styled_components_browser_esm/* default */.ZP)(Form/* default */.Z).withConfig({
    componentId: "sc-65008ae9-0"
})(FilePickerStyles_templateObject());
var FilePickerStyles_FormGroup = (0,styled_components_browser_esm/* default */.ZP)(FormGroup/* default */.Z).withConfig({
    componentId: "sc-65008ae9-1"
})(FilePickerStyles_templateObject1());
var FilePickerStyles_Label = (0,styled_components_browser_esm/* default */.ZP)(Label/* default */.Z).withConfig({
    componentId: "sc-65008ae9-2"
})(FilePickerStyles_templateObject2());
var Footnote = styled_components_browser_esm/* default.small.withConfig */.ZP.small.withConfig({
    componentId: "sc-65008ae9-3"
})(FilePickerStyles_templateObject3(), function(props) {
    return props.theme.gray600;
});
var ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65008ae9-4"
})(_templateObject4());
var FlexRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65008ae9-5"
})(_templateObject5());
var FlexColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65008ae9-6"
})(_templateObject6());
var FlexBottom = (0,styled_components_browser_esm/* default */.ZP)(FlexColumn).withConfig({
    componentId: "sc-65008ae9-7"
})(_templateObject7());
var FlexRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65008ae9-8"
})(_templateObject8());
var FlexLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65008ae9-9"
})(_templateObject9());
var FlexFill = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65008ae9-10"
})(_templateObject10());
var RowFill = (0,styled_components_browser_esm/* default */.ZP)(Row/* default */.Z).withConfig({
    componentId: "sc-65008ae9-11"
})(_templateObject11());
var ColFlexVertical = (0,styled_components_browser_esm/* default */.ZP)(Col/* default */.Z).withConfig({
    componentId: "sc-65008ae9-12"
})(_templateObject12());
var ColFlexHorizontal = (0,styled_components_browser_esm/* default */.ZP)(Col/* default */.Z).withConfig({
    componentId: "sc-65008ae9-13"
})(_templateObject13());
var FlexCenter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65008ae9-14"
})(_templateObject14());

// EXTERNAL MODULE: ./node_modules/react-loader-spinner/dist/esm/index.js + 21 modules
var esm = __webpack_require__(72846);
;// CONCATENATED MODULE: ./src/components/FilePicker/UploadedFileLoadingInfo.tsx
function UploadedFileLoadingInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function UploadedFileLoadingInfo_templateObject() {
    var data = UploadedFileLoadingInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1 0 100%;\n  flex-grow: 1;\n  border: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    UploadedFileLoadingInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a307b6de-0"
})(UploadedFileLoadingInfo_templateObject(), function(props) {
    return props.theme.filePicker.border.normal;
}, function(props) {
    return props.theme.filePicker.borderRadius;
});
function UploadedFileLoadingInfo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexCenter, {
            className: "m-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ThreeDots */.g4, {
                width: 20,
                height: 20,
                color: "#aaa"
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/reactstrap/es/Button.js
var Button = __webpack_require__(21602);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(72607);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var es = __webpack_require__(13966);
// EXTERNAL MODULE: ./src/helpers/sanitizeError.ts
var sanitizeError = __webpack_require__(86607);
;// CONCATENATED MODULE: ./src/components/FilePicker/useUploadZone.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent1, args1, Class1) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _wrapNativeSuper(Class2) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class2);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}





var UploadZoneState;
(function(UploadZoneState) {
    UploadZoneState["normal"] = "normal";
    UploadZoneState["accept"] = "accept";
    UploadZoneState["reject"] = "reject";
    UploadZoneState["hover"] = "hover";
})(UploadZoneState || (UploadZoneState = {}));
function useUploadZone(param) {
    var onUpload = param.onUpload, _multiple = param.multiple, multiple = _multiple === void 0 ? false : _multiple;
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var ref = (0,react.useState)([]), errors = ref[0], setErrors = ref[1];
    var hasErrors = errors.length > 0;
    var ref1 = (0,es/* useDropzone */.uI)({
        onDrop: makeOnDrop({
            t: t,
            onUpload: onUpload,
            setErrors: setErrors,
            multiple: multiple
        }),
        multiple: multiple
    }), getRootProps = ref1.getRootProps, getInputProps = ref1.getInputProps, isDragActive = ref1.isDragActive, isDragAccept = ref1.isDragAccept, isDragReject = ref1.isDragReject;
    var state = UploadZoneState.normal;
    if (isDragAccept) state = UploadZoneState.accept;
    else if (isDragReject) state = UploadZoneState.reject;
    return {
        state: state,
        errors: errors,
        hasErrors: hasErrors,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        isDragActive: isDragActive
    };
}
function makeOnDrop(param) {
    var t = param.t, onUpload = param.onUpload, setErrors = param.setErrors, multiple = param.multiple;
    var handleError = function handleError(error) {
        if (_instanceof(error, UploadErrorTooManyFiles)) {
            setErrors(function(prevErrors) {
                return _toConsumableArray(prevErrors).concat([
                    t("Only one file is expected")
                ]);
            });
        } else if (_instanceof(error, UploadErrorUnknown)) {
            setErrors(function(prevErrors) {
                return _toConsumableArray(prevErrors).concat([
                    t("Unknown error")
                ]);
            });
        } else {
            throw error;
        }
    };
    function processFiles(acceptedFiles, rejectedFiles) {
        return _processFiles.apply(this, arguments);
    }
    function _processFiles() {
        _processFiles = _asyncToGenerator(runtime_default().mark(function _callee(acceptedFiles, rejectedFiles) {
            var nFiles;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        nFiles = acceptedFiles.length + rejectedFiles.length;
                        if (!(!multiple && nFiles > 1 || !multiple && acceptedFiles.length > 1)) {
                            _ctx.next = 3;
                            break;
                        }
                        throw new UploadErrorTooManyFiles(nFiles);
                    case 3:
                        onUpload(acceptedFiles);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _processFiles.apply(this, arguments);
    }
    function onDrop(acceptedFiles, rejectedFiles) {
        return _onDrop.apply(this, arguments);
    }
    function _onDrop() {
        _onDrop = _asyncToGenerator(runtime_default().mark(function _callee(acceptedFiles, rejectedFiles) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setErrors([]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return processFiles(acceptedFiles, rejectedFiles);
                    case 4:
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](1);
                        handleError((0,sanitizeError/* sanitizeError */.b)(_ctx.t0));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    6
                ]
            ]);
        }));
        return _onDrop.apply(this, arguments);
    }
    return function(acceptedFiles, rejectedFiles) {
        // eslint-disable-next-line no-void
        void onDrop(acceptedFiles, rejectedFiles);
    };
}
function getUploadZoneTheme(props, elem) {
    return props.theme.uploadZone[elem][props.state];
}
var UploadErrorTooManyFiles = /*#__PURE__*/ function(Error) {
    "use strict";
    _inherits(UploadErrorTooManyFiles, Error);
    var _super = _createSuper(UploadErrorTooManyFiles);
    function UploadErrorTooManyFiles(nFiles) {
        _classCallCheck(this, UploadErrorTooManyFiles);
        var _this;
        _this = _super.call(this, "when uploading: one file is expected, but got ".concat(nFiles));
        _this.nFiles = nFiles;
        return _this;
    }
    return UploadErrorTooManyFiles;
}(_wrapNativeSuper(Error));
var UploadErrorUnknown = /*#__PURE__*/ function(Error) {
    "use strict";
    _inherits(UploadErrorUnknown, Error);
    var _super = _createSuper(UploadErrorUnknown);
    function UploadErrorUnknown() {
        _classCallCheck(this, UploadErrorUnknown);
        return _super.call(this, "when uploading: unknown error");
    }
    return UploadErrorUnknown;
}(_wrapNativeSuper(Error));

;// CONCATENATED MODULE: ./src/helpers/appendDash.ts
function appendDash(str) {
    return " - ".concat(str);
}

;// CONCATENATED MODULE: ./src/components/FilePicker/UploadBox.tsx
function UploadBox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function UploadBox_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            UploadBox_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function UploadBox_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = UploadBox_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function UploadBox_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function UploadBox_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function UploadBox_templateObject() {
    var data = UploadBox_taggedTemplateLiteral([
        "\n  width: 100%;\n\n  &:focus-within {\n    border: none;\n    inset: unset;\n    border-image: none;\n  }\n"
    ]);
    UploadBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UploadBox_templateObject1() {
    var data = UploadBox_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  min-height: ",
        ";\n  border-radius: ",
        ";\n  border: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    UploadBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UploadBox_templateObject2() {
    var data = UploadBox_taggedTemplateLiteral([
        ""
    ]);
    UploadBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UploadBox_templateObject3() {
    var data = UploadBox_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1 1 40%;\n  margin: auto;\n  margin-right: 20px;\n"
    ]);
    UploadBox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function UploadBox_templateObject4() {
    var data = UploadBox_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1 0 60%;\n"
    ]);
    UploadBox_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function UploadBox_templateObject5() {
    var data = UploadBox_taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    UploadBox_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function UploadBox_templateObject6() {
    var data = UploadBox_taggedTemplateLiteral([
        "\n  display: block;\n  margin: auto;\n  margin-left: 20px;\n"
    ]);
    UploadBox_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function UploadBox_templateObject7() {
    var data = UploadBox_taggedTemplateLiteral([
        "\n  font-size: 1.1rem;\n  text-align: center;\n  max-width: 150px;\n"
    ]);
    UploadBox_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function UploadBox_templateObject8() {
    var data = UploadBox_taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  min-width: 160px;\n  min-height: 50px;\n"
    ]);
    UploadBox_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}







var UploadZoneWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cdd809e-0"
})(UploadBox_templateObject());
var UploadZone = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cdd809e-1"
})(UploadBox_templateObject1(), function(props) {
    return props.theme.filePicker.minHeight;
}, function(props) {
    return props.theme.filePicker.borderRadius;
}, function(props) {
    return getUploadZoneTheme(props, "border");
}, function(props) {
    return getUploadZoneTheme(props, "color");
}, function(props) {
    return getUploadZoneTheme(props, "background");
}, function(props) {
    return getUploadZoneTheme(props, "box-shadow");
});
var UploadZoneInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-6cdd809e-2"
})(UploadBox_templateObject2());
var UploadZoneLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cdd809e-3"
})(UploadBox_templateObject3());
var UploadZoneRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cdd809e-4"
})(UploadBox_templateObject4());
var FileIconsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cdd809e-5"
})(UploadBox_templateObject5());
var UploadZoneTextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cdd809e-6"
})(UploadBox_templateObject6());
var UploadZoneText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cdd809e-7"
})(UploadBox_templateObject7());
var UploadZoneButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-6cdd809e-8"
})(UploadBox_templateObject8());
function UploadBox(_param) {
    var onUpload = _param.onUpload, children = _param.children, _multiple = _param.multiple, multiple = _multiple === void 0 ? false : _multiple, props = UploadBox_objectWithoutProperties(_param, [
        "onUpload",
        "children",
        "multiple"
    ]);
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var ref = useUploadZone({
        onUpload: onUpload,
        multiple: multiple
    }), state = ref.state, errors = ref.errors, hasErrors = ref.hasErrors, getRootProps = ref.getRootProps, getInputProps = ref.getInputProps, isDragActive = ref.isDragActive;
    if (hasErrors) {
        console.warn("Errors when uploading:\n".concat(errors.map(appendDash).join("\n")));
    }
    var normal = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadZoneTextContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadZoneText, {
                    children: t("Drag & drop files or folders")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadZoneButton, {
                    color: "primary",
                    children: t("Select files")
                })
            ]
        });
    }, [
        t
    ]);
    var active = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadZoneTextContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadZoneText, {
                children: t("Drop it!")
            })
        });
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadZoneWrapper, UploadBox_objectSpread({}, getRootProps(), props, {
        title: t("Drag & drop or select files"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadZoneInput, UploadBox_objectSpread({
                type: "file"
            }, getInputProps())),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadZone, {
                state: state,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadZoneLeft, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileIconsContainer, {
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadZoneRight, {
                        children: isDragActive ? active : normal
                    })
                ]
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/components/FilePicker/UploadBoxCompact.tsx
function UploadBoxCompact_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function UploadBoxCompact_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            UploadBoxCompact_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function UploadBoxCompact_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = UploadBoxCompact_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function UploadBoxCompact_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function UploadBoxCompact_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function UploadBoxCompact_templateObject() {
    var data = UploadBoxCompact_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n\n  width: 100%;\n  height: 100%;\n\n  &:focus-within {\n    border: none;\n    inset: unset;\n    border-image: none;\n  }\n"
    ]);
    UploadBoxCompact_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UploadBoxCompact_templateObject1() {
    var data = UploadBoxCompact_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  min-height: 57px;\n  border-radius: 5px;\n  border: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    UploadBoxCompact_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UploadBoxCompact_templateObject2() {
    var data = UploadBoxCompact_taggedTemplateLiteral([
        ""
    ]);
    UploadBoxCompact_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UploadBoxCompact_templateObject3() {
    var data = UploadBoxCompact_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 0 0;\n  height: 100%;\n"
    ]);
    UploadBoxCompact_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function UploadBoxCompact_templateObject4() {
    var data = UploadBoxCompact_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1 1 100%;\n  height: 100%;\n"
    ]);
    UploadBoxCompact_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function UploadBoxCompact_templateObject5() {
    var data = UploadBoxCompact_taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n"
    ]);
    UploadBoxCompact_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function UploadBoxCompact_templateObject6() {
    var data = UploadBoxCompact_taggedTemplateLiteral([
        "\n  flex: 1;\n  margin: auto;\n  text-align: center;\n  font-size: 1.1rem;\n"
    ]);
    UploadBoxCompact_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function UploadBoxCompact_templateObject7() {
    var data = UploadBoxCompact_taggedTemplateLiteral([
        "\n  flex: 0 0 120px;\n  margin-left: auto;\n"
    ]);
    UploadBoxCompact_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}







var UploadBoxCompact_UploadZoneWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c688c091-0"
})(UploadBoxCompact_templateObject());
var UploadBoxCompact_UploadZone = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c688c091-1"
})(UploadBoxCompact_templateObject1(), function(props) {
    return getUploadZoneTheme(props, "border");
}, function(props) {
    return getUploadZoneTheme(props, "color");
}, function(props) {
    return getUploadZoneTheme(props, "background");
}, function(props) {
    return getUploadZoneTheme(props, "box-shadow");
});
var UploadBoxCompact_UploadZoneInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-c688c091-2"
})(UploadBoxCompact_templateObject2());
var UploadBoxCompact_UploadZoneLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c688c091-3"
})(UploadBoxCompact_templateObject3());
var UploadBoxCompact_UploadZoneRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c688c091-4"
})(UploadBoxCompact_templateObject4());
var UploadBoxCompact_UploadZoneTextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c688c091-5"
})(UploadBoxCompact_templateObject5());
var UploadBoxCompact_UploadZoneText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c688c091-6"
})(UploadBoxCompact_templateObject6());
var UploadBoxCompact_UploadZoneButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-c688c091-7"
})(UploadBoxCompact_templateObject7());
function UploadBoxCompact(_param) {
    var onUpload = _param.onUpload, children = _param.children, props = UploadBoxCompact_objectWithoutProperties(_param, [
        "onUpload",
        "children"
    ]);
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var ref = useUploadZone({
        onUpload: onUpload,
        multiple: true
    }), state = ref.state, errors = ref.errors, hasErrors = ref.hasErrors, getRootProps = ref.getRootProps, getInputProps = ref.getInputProps, isDragActive = ref.isDragActive;
    if (hasErrors) {
        console.warn("Errors when uploading:\n".concat(errors.map(appendDash).join("\n")));
    }
    var normal = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadBoxCompact_UploadZoneTextContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadBoxCompact_UploadZoneText, {
                    children: t("Drag & drop a file ")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadBoxCompact_UploadZoneButton, {
                    color: "primary",
                    children: t("Select a file")
                })
            ]
        });
    }, [
        t
    ]);
    var active = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadBoxCompact_UploadZoneTextContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadBoxCompact_UploadZoneText, {
                children: t("Drop it!")
            })
        });
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadBoxCompact_UploadZoneWrapper, UploadBoxCompact_objectSpread({}, getRootProps(), props, {
        title: t("Drag & drop or select a file"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadBoxCompact_UploadZoneInput, UploadBoxCompact_objectSpread({
                type: "file"
            }, getInputProps())),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadBoxCompact_UploadZoneLeft, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadBoxCompact_UploadZoneRight, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadBoxCompact_UploadZone, {
                    state: state,
                    children: isDragActive ? active : normal
                })
            })
        ]
    }));
}

// EXTERNAL MODULE: ./node_modules/reactstrap/es/Input.js
var Input = __webpack_require__(39921);
;// CONCATENATED MODULE: ./src/components/FilePicker/TextInputMonospace.tsx
function TextInputMonospace_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function TextInputMonospace_templateObject() {
    var data = TextInputMonospace_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n"
    ]);
    TextInputMonospace_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TextInputMonospace_templateObject1() {
    var data = TextInputMonospace_taggedTemplateLiteral([
        "\n  font-family: ",
        ";\n  font-size: 0.75rem;\n  border-radius: 3px;\n  box-shadow: inset 2px 1px 3px #2222;\n  resize: none;\n  word-break: break-all;\n  word-wrap: break-word;\n  text-wrap: unrestricted;\n"
    ]);
    TextInputMonospace_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var TextInputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ff30186-0"
})(TextInputMonospace_templateObject());
var TextInputMonospace = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-1ff30186-1"
})(TextInputMonospace_templateObject1(), function(props) {
    return props.theme.font.monospace;
});

;// CONCATENATED MODULE: ./src/components/FilePicker/TabPanelUrl.tsx
function TabPanelUrl_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function TabPanelUrl_templateObject() {
    var data = TabPanelUrl_taggedTemplateLiteral([
        "\n  width: 100px;\n"
    ]);
    TabPanelUrl_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabPanelUrl_templateObject1() {
    var data = TabPanelUrl_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 5px;\n  margin: 0;\n"
    ]);
    TabPanelUrl_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ButtonStyled = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-889744d6-0"
})(TabPanelUrl_templateObject());
var TabPanelUrl_Form = (0,styled_components_browser_esm/* default */.ZP)(FilePickerStyles_Form).withConfig({
    componentId: "sc-889744d6-1"
})(TabPanelUrl_templateObject1());
function TabPanelUrl(param) {
    var exampleUrl = param.exampleUrl, onConfirm = param.onConfirm, inputRef = param.inputRef;
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var ref = (0,react.useState)(""), url = ref[0], setUrl = ref[1];
    var hasUrl = url.length > 0;
    var change = (0,react.useCallback)(function(e) {
        setUrl(e.target.value);
    }, []);
    var clear = (0,react.useCallback)(function() {
        setUrl("");
    }, []);
    var confirm = (0,react.useCallback)(function() {
        onConfirm(url);
        clear();
    }, [
        onConfirm,
        url,
        clear
    ]);
    var placeholder = (0,react.useMemo)(function() {
        return t("For example: {{exampleUrl}}", {
            exampleUrl: exampleUrl
        });
    }, [
        t,
        exampleUrl
    ]);
    var instructions = t("Enter URL to a file to fetch");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanelUrl_Form, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            noGutters: true,
            className: "w-100 h-100",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                className: "w-100 h-100 d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label/* default */.Z, {
                        className: "w-100 h-100 d-flex flex-column flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "w-100 flex-grow-0",
                                children: instructions
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputMonospace, {
                                className: "w-100 flex-grow-1",
                                type: "textarea",
                                placeholder: placeholder,
                                autoComplete: "off",
                                autoCorrect: "off",
                                autoCapitalize: "off",
                                spellCheck: "false",
                                "data-gramm": "false",
                                wrap: "hard",
                                "data-gramm_editor": "false",
                                value: url,
                                onChange: change,
                                innerRef: inputRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footnote, {
                        children: t("*Make sure this file is publicly accessible and CORS is enabled on your server")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "mr-auto",
                                disabled: !hasUrl,
                                type: "button",
                                color: "link",
                                title: t("Clear the URL text field"),
                                onClick: clear,
                                children: t("Clear")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonStyled, {
                                className: "ml-auto",
                                disabled: !hasUrl,
                                type: "button",
                                color: "primary",
                                title: hasUrl ? "Start downloading this file" : "Provide a URL before downloading is possible",
                                onClick: confirm,
                                children: t("OK")
                            })
                        ]
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/FilePicker/TabPanelPaste.tsx
function TabPanelPaste_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function TabPanelPaste_templateObject() {
    var data = TabPanelPaste_taggedTemplateLiteral([
        "\n  width: 100px;\n"
    ]);
    TabPanelPaste_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabPanelPaste_templateObject1() {
    var data = TabPanelPaste_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 5px;\n  margin: 0;\n"
    ]);
    TabPanelPaste_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var TabPanelPaste_ButtonStyled = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-17464269-0"
})(TabPanelPaste_templateObject());
var TabPanelPaste_Form = (0,styled_components_browser_esm/* default */.ZP)(FilePickerStyles_Form).withConfig({
    componentId: "sc-17464269-1"
})(TabPanelPaste_templateObject1());
function TabPanelPaste(param) {
    var onConfirm = param.onConfirm, instructions = param.instructions, inputRef = param.inputRef;
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var ref = (0,react.useState)(""), seqData = ref[0], setSeqData = ref[1];
    var hasSeqData = seqData.length > 0;
    var change = (0,react.useCallback)(function(e) {
        setSeqData(e.target.value);
    }, []);
    var clear = (0,react.useCallback)(function() {
        setSeqData("");
    }, []);
    var confirm = (0,react.useCallback)(function() {
        onConfirm(seqData);
        clear();
    }, [
        onConfirm,
        seqData,
        clear
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanelPaste_Form, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            noGutters: true,
            className: "w-100 h-100",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                className: "w-100 h-100 d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label/* default */.Z, {
                        className: "w-100 h-100 d-flex flex-column flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "w-100 flex-grow-0",
                                children: instructions
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputMonospace, {
                                className: "w-100 flex-grow-1",
                                type: "textarea",
                                autoComplete: "off",
                                autoCorrect: "off",
                                autoCapitalize: "off",
                                spellCheck: "false",
                                "data-gramm": "false",
                                wrap: "hard",
                                "data-gramm_editor": "false",
                                value: seqData,
                                onChange: change,
                                innerRef: inputRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "mr-auto",
                                disabled: !hasSeqData,
                                type: "button",
                                color: "link",
                                title: t("Clear the text field"),
                                onClick: clear,
                                children: t("Clear")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanelPaste_ButtonStyled, {
                                className: "ml-auto",
                                disabled: !hasSeqData,
                                type: "button",
                                color: "primary",
                                title: hasSeqData ? t("Accept the data") : t("Please provide the data first"),
                                onClick: confirm,
                                children: t("OK")
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(31382);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Alert.js
var Alert = __webpack_require__(83917);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(287);
// EXTERNAL MODULE: ./src/theme.ts
var theme = __webpack_require__(32082);
// EXTERNAL MODULE: ./src/components/Error/ErrorContent.tsx + 6 modules
var ErrorContent = __webpack_require__(79117);
;// CONCATENATED MODULE: ./src/components/FilePicker/UploadedFileInfo.tsx
function UploadedFileInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function UploadedFileInfo_templateObject() {
    var data = UploadedFileInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n"
    ]);
    UploadedFileInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UploadedFileInfo_templateObject1() {
    var data = UploadedFileInfo_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  border: ",
        ";\n  border-radius: ",
        ";\n  min-height: ",
        ";\n"
    ]);
    UploadedFileInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UploadedFileInfo_templateObject2() {
    var data = UploadedFileInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  margin: auto;\n"
    ]);
    UploadedFileInfo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UploadedFileInfo_templateObject3() {
    var data = UploadedFileInfo_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  margin-top: 1rem;\n"
    ]);
    UploadedFileInfo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function UploadedFileInfo_templateObject4() {
    var data = UploadedFileInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  margin: auto;\n"
    ]);
    UploadedFileInfo_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function UploadedFileInfo_templateObject5() {
    var data = UploadedFileInfo_taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    UploadedFileInfo_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function UploadedFileInfo_templateObject6() {
    var data = UploadedFileInfo_taggedTemplateLiteral([
        "\n  display: block;\n  margin: auto;\n  text-align: center;\n"
    ]);
    UploadedFileInfo_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function UploadedFileInfo_templateObject7() {
    var data = UploadedFileInfo_taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    UploadedFileInfo_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function UploadedFileInfo_templateObject8() {
    var data = UploadedFileInfo_taggedTemplateLiteral([
        "\n  font-size: 1.1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n"
    ]);
    UploadedFileInfo_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function UploadedFileInfo_templateObject9() {
    var data = UploadedFileInfo_taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  min-width: 160px;\n  min-height: 50px;\n"
    ]);
    UploadedFileInfo_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function UploadedFileInfo_templateObject10() {
    var data = UploadedFileInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  text-align: left;\n  box-shadow: ",
        ";\n"
    ]);
    UploadedFileInfo_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}









var UploadedFileInfo_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18a20e27-0"
})(UploadedFileInfo_templateObject());
var InfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18a20e27-1"
})(UploadedFileInfo_templateObject1(), function(props) {
    return props.theme.filePicker.border.normal;
}, function(props) {
    return props.theme.filePicker.borderRadius;
}, function(props) {
    return props.theme.filePicker.minHeight;
});
var InfoWrapperInternal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18a20e27-2"
})(UploadedFileInfo_templateObject2());
var ErrorWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18a20e27-3"
})(UploadedFileInfo_templateObject3());
var ErrorWrapperInternal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18a20e27-4"
})(UploadedFileInfo_templateObject4());
var IconsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18a20e27-5"
})(UploadedFileInfo_templateObject5());
var TextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18a20e27-6"
})(UploadedFileInfo_templateObject6());
var UploadedFileInfo_ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18a20e27-7"
})(UploadedFileInfo_templateObject7());
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18a20e27-8"
})(UploadedFileInfo_templateObject8());
var RemoveButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-18a20e27-9"
})(UploadedFileInfo_templateObject9());
var FileErrorStyled = (0,styled_components_browser_esm/* default */.ZP)(Alert/* default */.Z).withConfig({
    componentId: "sc-18a20e27-10"
})(UploadedFileInfo_templateObject10(), function(props) {
    return props.theme.shadows.slight;
});
function FileStatusIcon(param) {
    var hasErrors = param.hasErrors;
    var ICON_SIZE = 70;
    if (hasErrors) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdCloseCircle */.mpJ, {
            size: ICON_SIZE,
            color: theme/* theme.danger */.rS.danger
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdCheckmarkCircle */.Meg, {
        size: ICON_SIZE,
        color: theme/* theme.success */.rS.success
    });
}
function FileError(param) {
    var error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FileErrorStyled, {
        color: "danger",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorContent/* ErrorContent */.Qv, {
            error: error
        })
    });
}
function UploadedFileInfo(param) {
    var description = param.description, error = param.error, onRemove = param.onRemove;
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var hasErrors = !(0,lodash.isNil)(error);
    var errorComponent = (0,react.useMemo)(function() {
        return error && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorWrapperInternal, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileError, {
                    error: error
                }, error)
            })
        });
    }, [
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadedFileInfo_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapperInternal, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            noGutters: true,
                            className: "my-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconsContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileStatusIcon, {
                                        hasErrors: hasErrors
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            noGutters: true,
                            className: "my-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                        children: description
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            noGutters: true,
                            className: "my-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedFileInfo_ButtonContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveButton, {
                                        color: "secondary",
                                        onClick: onRemove,
                                        children: t("Remove")
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            errorComponent
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/FilePicker/UploadedFileInfoCompact.tsx
function UploadedFileInfoCompact_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function UploadedFileInfoCompact_templateObject() {
    var data = UploadedFileInfoCompact_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n\n  width: 100%;\n  height: 100%;\n\n  &:focus-within {\n    border: none;\n    inset: none;\n    border-image: none;\n  }\n"
    ]);
    UploadedFileInfoCompact_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UploadedFileInfoCompact_templateObject1() {
    var data = UploadedFileInfoCompact_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 0 0;\n  height: 100%;\n"
    ]);
    UploadedFileInfoCompact_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UploadedFileInfoCompact_templateObject2() {
    var data = UploadedFileInfoCompact_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1 1 100%;\n  height: 100%;\n"
    ]);
    UploadedFileInfoCompact_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UploadedFileInfoCompact_templateObject3() {
    var data = UploadedFileInfoCompact_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 100%;\n  min-height: 57px;\n  cursor: pointer;\n  border: 4px\n    ",
        "\n    solid;\n  background-color: ",
        ";\n  border-radius: 5px;\n"
    ]);
    UploadedFileInfoCompact_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function UploadedFileInfoCompact_templateObject4() {
    var data = UploadedFileInfoCompact_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1 1 100%;\n  margin: auto;\n  text-align: center;\n  font-size: 1.1rem;\n"
    ]);
    UploadedFileInfoCompact_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function UploadedFileInfoCompact_templateObject5() {
    var data = UploadedFileInfoCompact_taggedTemplateLiteral([
        "\n  flex: 0 0 50px;\n  margin: auto;\n  margin-left: 7px;\n"
    ]);
    UploadedFileInfoCompact_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function UploadedFileInfoCompact_templateObject6() {
    var data = UploadedFileInfoCompact_taggedTemplateLiteral([
        "\n  flex: 0 0 120px;\n  margin-left: auto;\n"
    ]);
    UploadedFileInfoCompact_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function UploadedFileInfoCompact_templateObject7() {
    var data = UploadedFileInfoCompact_taggedTemplateLiteral([
        "\n  font-size: 1.1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: auto 0;\n"
    ]);
    UploadedFileInfoCompact_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function UploadedFileInfoCompact_templateObject8() {
    var data = UploadedFileInfoCompact_taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  font-size: 0.9rem;\n  font-weight: light;\n"
    ]);
    UploadedFileInfoCompact_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function UploadedFileInfoCompact_templateObject9() {
    var data = UploadedFileInfoCompact_taggedTemplateLiteral([
        "\n  display: flex;\n  text-align: left;\n  margin: 5px auto;\n  max-width: 600px;\n  box-shadow: ",
        ";\n"
    ]);
    UploadedFileInfoCompact_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}











var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7e7baf1-0"
})(UploadedFileInfoCompact_templateObject());
var Left = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7e7baf1-1"
})(UploadedFileInfoCompact_templateObject1());
var Right = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7e7baf1-2"
})(UploadedFileInfoCompact_templateObject2());
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7e7baf1-3"
})(UploadedFileInfoCompact_templateObject3(), function(param) {
    var theme1 = param.theme, $hasErrors = param.$hasErrors;
    return $hasErrors ? theme1.uploadZone.background.reject : theme1.uploadZone.background.accept;
}, function(param) {
    var theme2 = param.theme, $hasErrors = param.$hasErrors;
    return $hasErrors ? theme2.uploadZone.background.reject : theme2.uploadZone.background.accept;
});
var UploadedFileInfoCompact_UploadZoneText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a7e7baf1-4"
})(UploadedFileInfoCompact_templateObject4());
var UploadedFileInfoCompact_FileIconsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7e7baf1-5"
})(UploadedFileInfoCompact_templateObject5());
var UploadedFileInfoCompact_UploadZoneButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-a7e7baf1-6"
})(UploadedFileInfoCompact_templateObject6());
var UploadZoneDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7e7baf1-7"
})(UploadedFileInfoCompact_templateObject7());
var UploadZoneTextOr = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7e7baf1-8"
})(UploadedFileInfoCompact_templateObject8());
var UploadedFileInfoCompact_FileErrorStyled = (0,styled_components_browser_esm/* default */.ZP)(Alert/* default */.Z).withConfig({
    componentId: "sc-a7e7baf1-9"
})(UploadedFileInfoCompact_templateObject9(), function(props) {
    return props.theme.shadows.slight;
});
function UploadedFileInfoCompact_FileStatusIcon(param) {
    var hasErrors = param.hasErrors;
    var ICON_SIZE = 30;
    if (hasErrors) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdCloseCircle */.mpJ, {
            size: ICON_SIZE,
            color: theme/* theme.danger */.rS.danger
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdCheckmarkCircle */.Meg, {
        size: ICON_SIZE,
        color: theme/* theme.success */.rS.success
    });
}
function UploadedFileInfoCompact_FileError(param) {
    var error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedFileInfoCompact_FileErrorStyled, {
        color: "danger",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorContent/* ErrorContent */.Qv, {
            error: error
        })
    });
}
function UploadedFileInfoCompact(param) {
    var children = param.children, description = param.description, error = param.error, onRemove = param.onRemove;
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var hasErrors = !(0,lodash.isNil)(error);
    var errorComponent = (0,react.useMemo)(function() {
        return error && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorWrapperInternal, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedFileInfoCompact_FileError, {
                    error: error
                }, error)
            })
        });
    }, [
        error
    ]);
    // NOTE: This currently uses the Tab layout, even there's no tabs (1 invisible tab).
    // This is in order to match the style of the main component's state, with tabs.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
        noGutters: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    noGutters: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Left, {
                                    children: children
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Right, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                                        $hasErrors: hasErrors,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedFileInfoCompact_FileIconsContainer, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedFileInfoCompact_FileStatusIcon, {
                                                    hasErrors: hasErrors
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadBoxCompact_UploadZoneTextContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedFileInfoCompact_UploadZoneText, {
                                                        children: description
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedFileInfoCompact_UploadZoneButton, {
                                                        color: "secondary",
                                                        onClick: onRemove,
                                                        children: t("Remove")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }),
                errorComponent
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/reactstrap/es/Dropdown.js
var Dropdown = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/DropdownToggle.js + 1 modules
var DropdownToggle = __webpack_require__(72047);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/DropdownMenu.js
var DropdownMenu = __webpack_require__(45259);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/DropdownItem.js
var DropdownItem = __webpack_require__(10225);
// EXTERNAL MODULE: ./src/components/Main/ButtonLoadExample.tsx
var ButtonLoadExample = __webpack_require__(54049);
// EXTERNAL MODULE: ./src/types.ts
var types = __webpack_require__(27037);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var recoil_es = __webpack_require__(16130);
// EXTERNAL MODULE: ./src/components/Common/SearchBox.tsx
var SearchBox = __webpack_require__(61011);
// EXTERNAL MODULE: ./src/helpers/search.ts
var search = __webpack_require__(53654);
// EXTERNAL MODULE: ./src/state/dataset.state.ts
var dataset_state = __webpack_require__(99902);
;// CONCATENATED MODULE: ./src/components/Main/ExampleSequencePicker.tsx
function ExampleSequencePicker_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ExampleSequencePicker_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ExampleSequencePicker_arrayLikeToArray(arr);
}
function ExampleSequencePicker_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ExampleSequencePicker_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ExampleSequencePicker_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ExampleSequencePicker_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ExampleSequencePicker_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ExampleSequencePicker_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ExampleSequencePicker_toConsumableArray(arr) {
    return ExampleSequencePicker_arrayWithoutHoles(arr) || ExampleSequencePicker_iterableToArray(arr) || ExampleSequencePicker_unsupportedIterableToArray(arr) || ExampleSequencePicker_nonIterableSpread();
}
function ExampleSequencePicker_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ExampleSequencePicker_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ExampleSequencePicker_arrayLikeToArray(o, minLen);
}
function ExampleSequencePicker_templateObject() {
    var data = ExampleSequencePicker_taggedTemplateLiteral([
        "\n  padding: 8px 16px !important;\n  border: 0;\n  box-shadow: inset 0 -1px 0 #ddd;\n  margin-bottom: 1px;\n"
    ]);
    ExampleSequencePicker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ExampleSequencePicker_templateObject1() {
    var data = ExampleSequencePicker_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  padding: 0;\n  margin: 0;\n"
    ]);
    ExampleSequencePicker_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ExampleSequencePicker_templateObject2() {
    var data = ExampleSequencePicker_taggedTemplateLiteral([
        "\n  position: absolute !important;\n  background-color: ",
        ";\n  box-shadow: 1px 1px 20px 0 #0005;\n  transition: opacity ease-out 0.25s;\n  padding: 1rem;\n  min-width: 275px;\n  z-index: 10000;\n"
    ]);
    ExampleSequencePicker_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ExampleSequencePicker_templateObject3() {
    var data = ExampleSequencePicker_taggedTemplateLiteral([
        "\n  width: 100% !important;\n  padding: 0 !important;\n"
    ]);
    ExampleSequencePicker_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ExampleSequencePicker_templateObject4() {
    var data = ExampleSequencePicker_taggedTemplateLiteral([
        "\n  margin-bottom: 0.5rem;\n  margin-right: 1rem;\n"
    ]);
    ExampleSequencePicker_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ExampleSequencePicker_templateObject5() {
    var data = ExampleSequencePicker_taggedTemplateLiteral([
        "\n  max-height: 50vh;\n  overflow-y: auto;\n"
    ]);
    ExampleSequencePicker_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}












function ExampleSequencePicker(_param) {
    var restProps = _extends({}, _param);
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var ref5 = (0,react.useState)(""), searchTerm = ref5[0], setSearchTerm = ref5[1];
    var ref1 = (0,react.useState)(false), dropdownOpen = ref1[0], setDropdownOpen = ref1[1];
    var toggle = (0,react.useCallback)(function() {
        setDropdownOpen(function(prevState) {
            return !prevState;
        });
    }, []);
    var allDatasets = (0,recoil_es/* useRecoilValue */.sJ)(dataset_state/* datasetsAtom */.gQ);
    var filtered = (0,react.useMemo)(function() {
        var datasets = allDatasets.filter(function(dataset) {
            var ref;
            return !(0,lodash.isNil)(dataset === null || dataset === void 0 ? void 0 : (ref = dataset.files) === null || ref === void 0 ? void 0 : ref.examples);
        });
        if (searchTerm.trim().length === 0) {
            return datasets;
        }
        var ref6, ref2, ref3;
        var ref4 = (0,search/* search */.yC)(datasets, searchTerm, function(dataset) {
            return [
                dataset.path,
                (ref6 = (0,types/* attrStrMaybe */.w8)(dataset.attributes, "name")) !== null && ref6 !== void 0 ? ref6 : "",
                (ref2 = (0,types/* attrStrMaybe */.w8)(dataset.attributes, "reference name")) !== null && ref2 !== void 0 ? ref2 : "",
                (ref3 = (0,types/* attrStrMaybe */.w8)(dataset.attributes, "reference accession")) !== null && ref3 !== void 0 ? ref3 : "",
                dataset.path, 
            ];
        }), itemsStartWith = ref4.itemsStartWith, itemsInclude = ref4.itemsInclude;
        return ExampleSequencePicker_toConsumableArray(itemsStartWith).concat(ExampleSequencePicker_toConsumableArray(itemsInclude));
    }, [
        allDatasets,
        searchTerm
    ]);
    var setExampleSequences = (0,ButtonLoadExample/* useSetExampleSequences */.c)();
    var onClick = (0,react.useCallback)(function(dataset) {
        return function() {
            setExampleSequences(dataset);
        };
    }, [
        setExampleSequences
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExampleSequencePicker_Dropdown, ExampleSequencePicker_objectSpread({
        isOpen: dropdownOpen,
        toggle: toggle
    }, restProps, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExampleSequencePicker_DropdownToggle, {
                nav: true,
                caret: true,
                children: t("Example")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExampleSequencePicker_DropdownMenu, {
                container: "body",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBoxWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox/* SearchBox */.R, {
                            searchTitle: t("Search examples"),
                            searchTerm: searchTerm,
                            onSearchTermChange: setSearchTerm
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenuListWrapper, {
                        children: filtered.map(function(dataset) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExampleSequencePicker_DropdownItem, {
                                onClick: onClick(dataset),
                                children: dataset.path
                            }, dataset.path);
                        })
                    })
                ]
            })
        ]
    }));
}
var ExampleSequencePicker_Dropdown = (0,styled_components_browser_esm/* default */.ZP)(Dropdown/* default */.Z).withConfig({
    componentId: "sc-3134e789-0"
})(ExampleSequencePicker_templateObject());
var ExampleSequencePicker_DropdownToggle = (0,styled_components_browser_esm/* default */.ZP)(DropdownToggle/* default */.Z).withConfig({
    componentId: "sc-3134e789-1"
})(ExampleSequencePicker_templateObject1(), function(props) {
    return props.theme.bodyColor;
});
var ExampleSequencePicker_DropdownMenu = (0,styled_components_browser_esm/* default */.ZP)(DropdownMenu/* default */.Z).withConfig({
    componentId: "sc-3134e789-2"
})(ExampleSequencePicker_templateObject2(), function(props) {
    return props.theme.bodyBg;
});
var ExampleSequencePicker_DropdownItem = (0,styled_components_browser_esm/* default */.ZP)(DropdownItem/* default */.Z).withConfig({
    componentId: "sc-3134e789-3"
})(ExampleSequencePicker_templateObject3());
var SearchBoxWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3134e789-4"
})(ExampleSequencePicker_templateObject4());
var DropdownMenuListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3134e789-5"
})(ExampleSequencePicker_templateObject5());

;// CONCATENATED MODULE: ./src/components/FilePicker/FilePicker.tsx
function FilePicker_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FilePicker_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FilePicker_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FilePicker_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = FilePicker_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function FilePicker_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function FilePicker_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FilePicker_templateObject() {
    var data = FilePicker_taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    FilePicker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilePicker_templateObject1() {
    var data = FilePicker_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-bottom: 10px;\n"
    ]);
    FilePicker_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FilePicker_templateObject2() {
    var data = FilePicker_taggedTemplateLiteral([
        "\n  flex: 1 0;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: ",
        ";\n"
    ]);
    FilePicker_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FilePicker_templateObject3() {
    var data = FilePicker_taggedTemplateLiteral([
        "\n  flex: 1 0;\n  padding-top: 0.75rem;\n  margin: auto 0;\n\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"
    ]);
    FilePicker_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FilePicker_templateObject4() {
    var data = FilePicker_taggedTemplateLiteral([
        "\n  * {\n    background: transparent !important;\n  }\n"
    ]);
    FilePicker_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FilePicker_templateObject5() {
    var data = FilePicker_taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    FilePicker_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}














var FilePickerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b7cc0d4d-0"
})(FilePicker_templateObject());
var FilePickerHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b7cc0d4d-1"
})(FilePicker_templateObject1());
var FilePickerBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b7cc0d4d-2"
})(FilePicker_templateObject2(), function(props) {
    return !props.$compact && props.theme.filePicker.minHeight;
});
var FilePickerTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-b7cc0d4d-3"
})(FilePicker_templateObject3());
var TabsPanelStyled = (0,styled_components_browser_esm/* default */.ZP)(TabsPanel).withConfig({
    componentId: "sc-b7cc0d4d-4"
})(FilePicker_templateObject4());
var TabsContentStyled = (0,styled_components_browser_esm/* default */.ZP)(TabsContent).withConfig({
    componentId: "sc-b7cc0d4d-5"
})(FilePicker_templateObject5());
function FilePicker(_param) {
    var _multiple = _param.multiple, multiple = _multiple === void 0 ? false : _multiple, compact = _param.compact, _title = _param.title, title = _title === void 0 ? "" : _title, icon = _param.icon, exampleUrl = _param.exampleUrl, pasteInstructions = _param.pasteInstructions, input = _param.input, error = _param.error, isInProgress = _param.isInProgress, onInput = _param.onInput, onInputs = _param.onInputs, onRemove = _param.onRemove, onError = _param.onError, inputRef = _param.inputRef, props = FilePicker_objectWithoutProperties(_param, [
        "multiple",
        "compact",
        "title",
        "icon",
        "exampleUrl",
        "pasteInstructions",
        "input",
        "error",
        "isInProgress",
        "onInput",
        "onInputs",
        "onRemove",
        "onError",
        "inputRef"
    ]);
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var ref = (0,react.useState)("file"), activeTab = ref[0], setActiveTab = ref[1];
    var onFiles = (0,react.useCallback)(function(files) {
        if (multiple) {
            onInputs === null || onInputs === void 0 ? void 0 : onInputs(files.map(function(file) {
                return new AlgorithmInput/* AlgorithmInputFile */.NG(file);
            }));
        } else if (files.length > 0) {
            onInput === null || onInput === void 0 ? void 0 : onInput(new AlgorithmInput/* AlgorithmInputFile */.NG(files[0]));
        }
    }, [
        multiple,
        onInput,
        onInputs
    ]);
    var onUrl = (0,react.useCallback)(function(url) {
        if (multiple) {
            onInputs === null || onInputs === void 0 ? void 0 : onInputs([
                new AlgorithmInput/* AlgorithmInputUrl */.nq(url)
            ]);
        } else {
            onInput === null || onInput === void 0 ? void 0 : onInput(new AlgorithmInput/* AlgorithmInputUrl */.nq(url));
        }
    }, [
        multiple,
        onInput,
        onInputs
    ]);
    var onPaste = (0,react.useCallback)(function(content) {
        if (multiple) {
            onInputs === null || onInputs === void 0 ? void 0 : onInputs([
                new AlgorithmInput/* AlgorithmInputString */.CA(content, t("Pasted text"))
            ]);
        } else {
            onInput === null || onInput === void 0 ? void 0 : onInput(new AlgorithmInput/* AlgorithmInputString */.CA(content, t("Pasted text")));
        }
    }, [
        multiple,
        onInput,
        onInputs,
        t
    ]);
    // eslint-disable-next-line no-void
    void onError;
    var clearAndRemove = (0,react.useCallback)(function() {
        onRemove === null || onRemove === void 0 ? void 0 : onRemove([]);
    }, [
        onRemove
    ]);
    var tabs = (0,react.useMemo)(function() {
        return [
            {
                name: "file",
                title: t("File"),
                body: compact ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadBoxCompact, {
                    onUpload: onFiles,
                    children: icon
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadBox, {
                    onUpload: onFiles,
                    multiple: true,
                    children: icon
                })
            },
            {
                name: "link",
                title: t("Link"),
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanelUrl, {
                    onConfirm: onUrl,
                    exampleUrl: exampleUrl
                })
            },
            {
                name: "text",
                title: t("Text"),
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanelPaste, {
                    onConfirm: onPaste,
                    instructions: pasteInstructions,
                    inputRef: inputRef
                })
            }, 
        ];
    }, [
        compact,
        exampleUrl,
        icon,
        inputRef,
        onFiles,
        onPaste,
        onUrl,
        pasteInstructions,
        t
    ]);
    var FileUploadOrFileInfo = (0,react.useMemo)(function() {
        if (isInProgress) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedFileLoadingInfo, {});
        }
        if (input) {
            return compact ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedFileInfoCompact, {
                description: input.description,
                error: error,
                onRemove: clearAndRemove,
                children: icon
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedFileInfo, {
                description: input.description,
                error: error,
                onRemove: clearAndRemove
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContentStyled, {
            tabs: tabs,
            activeTab: activeTab
        });
    }, [
        activeTab,
        clearAndRemove,
        compact,
        error,
        icon,
        input,
        isInProgress,
        tabs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilePickerContainer, FilePicker_objectSpread({}, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilePickerHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilePickerTitle, {
                        title: title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPanelStyled, {
                        tabs: tabs,
                        activeTab: activeTab,
                        onChange: setActiveTab,
                        disabled: !!input || isInProgress
                    }),
                    !compact && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExampleSequencePicker, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilePickerBody, {
                $compact: compact,
                children: FileUploadOrFileInfo
            })
        ]
    }));
}


/***/ }),

/***/ 85800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SelectDatasetHelp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60822);
/* harmony import */ var src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87181);
/* harmony import */ var src_components_Common_InfoButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79227);
/* harmony import */ var src_components_Link_LinkExternal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28072);





function SelectDatasetHelp() {
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_2__/* .useTranslationSafe */ ._)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Common_InfoButton__WEBPACK_IMPORTED_MODULE_3__/* .InfoButton */ .R, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: t("Nextclade software is built to be agnostic to pathogens it analyzes. The information about concrete pathogens is provided in the form of so-called Nextclade datasets.")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: t("Datasets vary by the pathogen, strain and other attributes. Each dataset is based on a particular reference sequence. Certain datasets only have enough information for basic analysis, others - more information to allow for more in-depth analysis and checks. Dataset authors periodically update and improve their datasets.")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: t("You can select one of the datasets manually or to use automatic dataset suggestion function. Automatic suggestion will attempt to guess the most appropriate dataset from your sequence data.")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: t("If you don't find a dataset for a pathogen or a strain you need, then you can create your own dataset. You can also publish it to our community collection, so that other people can use it too.")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "p-0 m-0 small",
                children: [
                    t("Learn more in Nextclade {{documentation}}"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Link_LinkExternal__WEBPACK_IMPORTED_MODULE_4__/* .LinkExternal */ .N, {
                        href: "https://docs.nextstrain.org/projects/nextclade/en/stable",
                        children: t("documentation")
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 54049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ ButtonLoadExample; },
/* harmony export */   "c": function() { return /* binding */ useSetExampleSequences; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60822);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21602);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16130);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37536);
/* harmony import */ var src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87181);
/* harmony import */ var src_hooks_useRunSeqAutodetect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33035);
/* harmony import */ var src_io_AlgorithmInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75583);
/* harmony import */ var src_state_error_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57635);
/* harmony import */ var src_state_inputs_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67821);
/* harmony import */ var src_state_settings_state__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99664);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 300px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  &:disabled {\n    text-decoration: none !important;\n    pointer-events: all !important;\n    cursor: not-allowed !important;\n    transition: none !important;\n  }\n\n  transition: none !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











function useSetExampleSequences() {
    var addQryInputs = (0,src_state_inputs_state__WEBPACK_IMPORTED_MODULE_7__/* .useQuerySeqInputs */ .HT)().addQryInputs;
    var shouldSuggestDatasets = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_state_settings_state__WEBPACK_IMPORTED_MODULE_8__/* .shouldSuggestDatasetsOnDatasetPageAtom */ .Ji);
    var runAutodetect = (0,src_hooks_useRunSeqAutodetect__WEBPACK_IMPORTED_MODULE_4__/* .useRunSeqAutodetect */ .oh)();
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(dataset) {
        if (dataset) {
            addQryInputs([
                new src_io_AlgorithmInput__WEBPACK_IMPORTED_MODULE_5__/* .AlgorithmInputDefault */ .Ok(dataset)
            ]);
            if (shouldSuggestDatasets) {
                runAutodetect();
            }
        }
    }, [
        addQryInputs,
        runAutodetect,
        shouldSuggestDatasets
    ]);
}
function ButtonLoadExample(_param) {
    var dataset = _param.dataset, rest = _objectWithoutProperties(_param, [
        "dataset"
    ]);
    var ref2, ref1;
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_3__/* .useTranslationSafe */ ._)().t;
    var hasInputErrors = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_state_error_state__WEBPACK_IMPORTED_MODULE_6__/* .hasInputErrorsAtom */ .Ly);
    var setExampleSequences = useSetExampleSequences();
    var onClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setExampleSequences(dataset);
    }, [
        dataset,
        setExampleSequences
    ]);
    var title = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        return (dataset === null || dataset === void 0 ? void 0 : (ref = dataset.files) === null || ref === void 0 ? void 0 : ref.examples) ? t("Load example sequence data (for demonstration)") : t("There is no example data in this dataset");
    }, [
        dataset === null || dataset === void 0 ? void 0 : (ref2 = dataset.files) === null || ref2 === void 0 ? void 0 : ref2.examples,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonStyled, _objectSpread({}, rest, {
        color: "link",
        onClick: onClick,
        title: title,
        disabled: !(dataset === null || dataset === void 0 ? void 0 : (ref1 = dataset.files) === null || ref1 === void 0 ? void 0 : ref1.examples) || hasInputErrors || !dataset,
        children: t("Load example")
    }));
}
var ButtonStyled = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a1c73554-0"
})(_templateObject());


/***/ }),

/***/ 16968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ButtonRun; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60822);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21602);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16130);
/* harmony import */ var src_hooks_useRunAnalysis__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12860);
/* harmony import */ var src_state_dataset_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99902);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37536);
/* harmony import */ var src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87181);
/* harmony import */ var src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69068);
/* harmony import */ var src_state_error_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57635);
/* harmony import */ var src_state_inputs_state__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67821);
/* harmony import */ var src_state_results_state__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71355);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 150px;\n  min-height: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












function ButtonRun(_param) {
    var singleDatasetMode = _param.singleDatasetMode, restProps = _objectWithoutProperties(_param, [
        "singleDatasetMode"
    ]);
    var run = (0,src_hooks_useRunAnalysis__WEBPACK_IMPORTED_MODULE_3__/* .useRunAnalysis */ .B)();
    var onClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return run({
            isSingle: singleDatasetMode
        });
    }, [
        run,
        singleDatasetMode
    ]);
    var isAnalysisRunning = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_state_results_state__WEBPACK_IMPORTED_MODULE_9__/* .isAnalysisRunningAtom */ .JN);
    var hasRequiredInputs = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_state_inputs_state__WEBPACK_IMPORTED_MODULE_8__/* .hasRequiredInputsAtom */ .ZX);
    var hasInputErrors = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_state_error_state__WEBPACK_IMPORTED_MODULE_7__/* .hasInputErrorsAtom */ .Ly);
    var isAutodetectRunning = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_6__/* .isAutodetectRunningAtom */ .Kt);
    var hasSingleDataset = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_state_dataset_state__WEBPACK_IMPORTED_MODULE_4__/* .hasSingleCurrentDatasetAtom */ .hG);
    var hasMultiDatasets = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_6__/* .hasTopSuggestedDatasetsAtom */ .Ql);
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_5__/* .useTranslationSafe */ ._)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var hasDatasetsSelected = singleDatasetMode ? hasSingleDataset : hasMultiDatasets;
        var isDisabled = isAnalysisRunning || !(hasRequiredInputs && !isAutodetectRunning) || hasInputErrors || !hasDatasetsSelected;
        return {
            isDisabled: isDisabled,
            color: isDisabled ? "secondary" : "success",
            tooltip: isDisabled ? t("Please provide sequence data first") : t("Launch the algorithm!")
        };
    }, [
        singleDatasetMode,
        hasSingleDataset,
        hasMultiDatasets,
        isAnalysisRunning,
        hasRequiredInputs,
        isAutodetectRunning,
        hasInputErrors,
        t, 
    ]), isDisabled1 = ref.isDisabled, color = ref.color, tooltip = ref.tooltip;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonStyled, _objectSpread({
        disabled: isDisabled1,
        color: color,
        onClick: onClick,
        title: tooltip
    }, restProps, {
        children: t("Run")
    }));
}
var ButtonStyled = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d6dbf0ef-0"
})(_templateObject());


/***/ }),

/***/ 51787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GT": function() { return /* binding */ DatasetCustomizationsIndicatorLink; },
/* harmony export */   "pD": function() { return /* binding */ DatasetCustomizationIndicator; }
/* harmony export */ });
/* unused harmony export DatasetCustomizationIndicatorIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60822);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16130);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19343);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70146);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37536);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10872);
/* harmony import */ var src_components_Link_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59263);
/* harmony import */ var src_components_Common_ButtonTransparent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13707);
/* harmony import */ var src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87181);
/* harmony import */ var src_state_inputs_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67821);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  width: ",
        "px;\n  height: ",
        "px;\n  border-radius: ",
        "px;\n  margin-left: 0.5rem;\n  padding: 0 0.25rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 90px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  &:hover {\n    text-decoration: ",
        " underline solid;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-left: 0.5rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  * {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










function DatasetCustomizationIndicator(_param) {
    var restProps = _extends({}, _param);
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_5__/* .useTranslationSafe */ ._)().t;
    var inputCustomizationCounter = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_state_inputs_state__WEBPACK_IMPORTED_MODULE_6__/* .inputCustomizationCounterAtom */ .LK);
    var text = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return t("Dataset files currently customized: {{n}}", {
            n: inputCustomizationCounter
        });
    }, [
        inputCustomizationCounter,
        t
    ]);
    if (inputCustomizationCounter === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DatasetCustomizationIndicatorIcon, _objectSpread({
        size: 20,
        title: text
    }, restProps, {
        children: inputCustomizationCounter
    }));
}
var DatasetCustomizationIndicatorIcon = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-e16eb98d-0"
})(_templateObject(), function(props) {
    return props.theme.gray200;
}, function(props) {
    return props.theme.danger;
}, function(props) {
    return props.size;
}, function(props) {
    return props.size;
}, function(props) {
    return props.size;
});
function DatasetCustomizationsIndicatorLink() {
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_5__/* .useTranslationSafe */ ._)().t;
    var inputCustomizationCounter = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_state_inputs_state__WEBPACK_IMPORTED_MODULE_6__/* .inputCustomizationCounterAtom */ .LK);
    var text = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return t("Dataset files currently customized: {{n}}", {
            n: inputCustomizationCounter
        });
    }, [
        inputCustomizationCounter,
        t
    ]);
    var resetCustomizations = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useResetRecoilState */ .rb)(src_state_inputs_state__WEBPACK_IMPORTED_MODULE_6__/* .datasetFilesResetAtom */ .JL);
    if (inputCustomizationCounter === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        noGutters: true,
        className: "d-flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            className: "d-flex mr-auto mt-2",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DatasetCustomizationWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "d-flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CustomizationLink, {
                            href: "/dataset#customize",
                            title: text,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-danger",
                                    children: t("Customizations")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DatasetCustomizationIndicator, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonClear, {
                            onClick: resetCustomizations,
                            title: t("Reset customizations"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconClear, {
                                size: 15
                            })
                        })
                    ]
                })
            })
        })
    });
}
var DatasetCustomizationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e16eb98d-1"
})(_templateObject1());
var CustomizationLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(src_components_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r).withConfig({
    componentId: "sc-e16eb98d-2"
})(_templateObject2(), function(props) {
    return props.theme.danger;
});
var ButtonClear = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(src_components_Common_ButtonTransparent__WEBPACK_IMPORTED_MODULE_4__/* .ButtonTransparent */ .h).withConfig({
    componentId: "sc-e16eb98d-3"
})(_templateObject3());
var IconClear = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdClear */ .lUB).withConfig({
    componentId: "sc-e16eb98d-4"
})(_templateObject4(), function(props) {
    return props.theme.gray500;
});


/***/ }),

/***/ 79488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ DatasetInfoAutodetectProgressCircle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31382);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60822);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16130);
/* harmony import */ var src_components_Main_DatasetInfo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37952);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37536);
/* harmony import */ var src_helpers_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96817);
/* harmony import */ var src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69068);
/* harmony import */ var src_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27037);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  font-size: 0.8rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: auto;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  width: 50px;\n  height: 50px;\n  font-size: 1rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









function DatasetInfoAutodetectProgressCircle(_param) {
    var dataset = _param.dataset, showSuggestions = _param.showSuggestions, restProps = _objectWithoutProperties(_param, [
        "dataset",
        "showSuggestions"
    ]);
    var attributes = dataset.attributes, path = dataset.path;
    var ref3, ref1;
    var name = (ref1 = (ref3 = (0,src_types__WEBPACK_IMPORTED_MODULE_7__/* .attrStrMaybe */ .w8)(attributes, "name")) !== null && ref3 !== void 0 ? ref3 : (0,lodash__WEBPACK_IMPORTED_MODULE_1__.last)(path.split("/"))) !== null && ref1 !== void 0 ? ref1 : "?";
    var circleBg = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,src_components_Main_DatasetInfo__WEBPACK_IMPORTED_MODULE_4__/* .datasetColor */ .lF)(path);
    }, [
        path
    ]);
    var seqIndices = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)((0,src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_6__/* .seqIndicesForDataset */ .iZ)(path));
    var numberAutodetectResults = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_6__/* .numberAutodetectResultsAtom */ .LO);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (!showSuggestions || (0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(seqIndices)) {
            var ref;
            return {
                circleText: ((ref = (0,src_helpers_string__WEBPACK_IMPORTED_MODULE_5__/* .firstLetter */ .i1)(name)) !== null && ref !== void 0 ? ref : " ").toUpperCase(),
                percentage: 0,
                countText: "\xa0"
            };
        }
        if (seqIndices.length > 0) {
            var percentage = seqIndices.length / numberAutodetectResults;
            var circleText = "".concat((100 * percentage).toFixed(0), "%");
            var countText = "".concat(seqIndices.length, " / ").concat(numberAutodetectResults);
            return {
                circleText: circleText,
                percentage: percentage,
                countText: countText
            };
        }
        return {
            circleText: "0%",
            percentage: 0,
            countText: "0 / ".concat(numberAutodetectResults)
        };
    }, [
        showSuggestions,
        seqIndices,
        numberAutodetectResults,
        name
    ]), circleText1 = ref2.circleText, countText1 = ref2.countText, percentage1 = ref2.percentage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CircleWrapper, _objectSpread({}, restProps, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CircleBorder, {
                $percentage: percentage1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Circle, {
                    $bg: circleBg,
                    children: circleText1
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CountText, {
                children: countText1
            })
        ]
    }));
}
var CircleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-36e283c7-0"
})(_templateObject());
var CountText = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-36e283c7-1"
})(_templateObject1());
var _$fg, _$bg;
var CircleBorder = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        style: {
            background: "\n      radial-gradient(closest-side, white 79%, transparent 80% 100%),\n      conic-gradient(\n        ".concat((_$fg = props.$fg) !== null && _$fg !== void 0 ? _$fg : props.theme.success, " calc(").concat(props.$percentage, " * 100%),\n        ").concat((_$bg = props.$bg) !== null && _$bg !== void 0 ? _$bg : "lightgray", " 0\n      )")
        }
    };
}).withConfig({
    componentId: "sc-36e283c7-2"
})(_templateObject2());
var _$bg1, _$fg1;
var Circle = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-36e283c7-3"
})(_templateObject3(), function(props) {
    return (_$bg1 = props.$bg) !== null && _$bg1 !== void 0 ? _$bg1 : props.theme.gray700;
}, function(props) {
    return (_$fg1 = props.$fg) !== null && _$fg1 !== void 0 ? _$fg1 : props.theme.gray100;
});


/***/ }),

/***/ 44969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ DatasetInfoCompact; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60822);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19343);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70146);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37536);
/* harmony import */ var src_components_Common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33859);
/* harmony import */ var src_components_Main_ButtonLoadExample__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54049);
/* harmony import */ var src_components_Main_DatasetInfoAutodetectProgressCircle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79488);
/* harmony import */ var src_components_Main_LinkOpenTree__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98409);
/* harmony import */ var src_components_Main_DatasetInfo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37952);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 8px 12px;\n  border: 1px #ccc9 solid;\n  border-radius: 5px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









function DatasetInfoCompact(_param) {
    var dataset = _param.dataset, restProps = _objectWithoutProperties(_param, [
        "dataset"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, _objectSpread({}, restProps, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            noGutters: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reactstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        noGutters: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Common_Flex__WEBPACK_IMPORTED_MODULE_2__/* .FlexContainer */ .Ej, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_Flex__WEBPACK_IMPORTED_MODULE_2__/* .FlexLeft */ .M9, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Main_DatasetInfoAutodetectProgressCircle__WEBPACK_IMPORTED_MODULE_4__/* .DatasetInfoAutodetectProgressCircle */ .W, {
                                            dataset: dataset,
                                            showSuggestions: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_Flex__WEBPACK_IMPORTED_MODULE_2__/* .FlexRight */ .Hz, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Main_DatasetInfo__WEBPACK_IMPORTED_MODULE_6__/* .DatasetInfo */ .Bu, {
                                            dataset: dataset
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        noGutters: true,
                        className: "d-flex w-100",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: "d-flex",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "d-flex ml-auto",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Main_LinkOpenTree__WEBPACK_IMPORTED_MODULE_5__/* .LinkOpenTree */ .$, {
                                        className: "ml-1",
                                        dataset: dataset
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Main_ButtonLoadExample__WEBPACK_IMPORTED_MODULE_3__/* .ButtonLoadExample */ .P, {
                                        className: "ml-1",
                                        dataset: dataset
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    }));
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4c08233a-0"
})(_templateObject());


/***/ }),

/***/ 98409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ LinkOpenTree; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94273);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60822);
/* harmony import */ var src_components_Link_LinkExternal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28072);
/* harmony import */ var src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87181);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37536);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44124);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(url_join__WEBPACK_IMPORTED_MODULE_5__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: auto 0;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n\n  &.disabled {\n    color: #7b838a !important;\n    opacity: 0.65 !important;\n    text-decoration: none;\n    cursor: not-allowed !important;\n    transition: none !important;\n  }\n\n  transition: none !important;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







function LinkOpenTree(param) {
    var dataset = param.dataset;
    var ref1;
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_4__/* .useTranslationSafe */ ._)().t;
    var nextstrainOrgTreeUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        if (!((ref = dataset.files) === null || ref === void 0 ? void 0 : ref.treeJson)) {
            return undefined;
        }
        var path = dataset.files.treeJson.replace(/^https?:\/\//, "");
        return url_join__WEBPACK_IMPORTED_MODULE_5___default()("https://nextstrain.org/fetch", path);
    }, [
        (ref1 = dataset.files) === null || ref1 === void 0 ? void 0 : ref1.treeJson
    ]);
    var title = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return nextstrainOrgTreeUrl ? t("Open reference tree for this dataset on nextstrain.org") : t("There is no reference tree in this dataset");
    }, [
        nextstrainOrgTreeUrl,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkContainer, {
        className: "mx-2",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkExternalStyled, {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(!nextstrainOrgTreeUrl && "disabled"),
            title: title,
            href: nextstrainOrgTreeUrl,
            children: t("Open tree")
        })
    });
}
var LinkContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d918d4b4-0"
})(_templateObject());
var LinkExternalStyled = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(src_components_Link_LinkExternal__WEBPACK_IMPORTED_MODULE_3__/* .LinkExternal */ .N).withConfig({
    componentId: "sc-d918d4b4-1"
})(_templateObject1());


/***/ }),

/***/ 55375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g2": function() { return /* binding */ QuerySequenceList; }
/* harmony export */ });
/* unused harmony exports Li, InputNameWrapper, InputName, InputFileInfo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60822);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69968);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10872);
/* harmony import */ var react_icons_ci__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57762);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21602);
/* harmony import */ var src_components_Common_ButtonTransparent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13707);
/* harmony import */ var src_components_Common_List__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54043);
/* harmony import */ var src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87181);
/* harmony import */ var src_state_inputs_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67821);
/* harmony import */ var src_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27037);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37536);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  overflow: auto;\n  max-height: 320px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 5px 0;\n  border-radius: 5px !important;\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n  width: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin: auto 5px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  padding: 0.5rem 1rem;\n  box-shadow: 0 0 12px 0 #0002;\n  border: 1px #ccc9 solid;\n  border-radius: 5px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  padding: 0;\n  margin: 0;\n  max-height: 1.5rem;\n  width: 25px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}












function QuerySequenceList(param) {
    var toMainPage = param.toMainPage;
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_4__/* .useTranslationSafe */ ._)().t;
    var ref = (0,src_state_inputs_state__WEBPACK_IMPORTED_MODULE_5__/* .useQuerySeqInputs */ .HT)(), qryInputs = ref.qryInputs, clearQryInputs = ref.clearQryInputs;
    var listItems = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return qryInputs.map(function(input, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Li, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputFileInfo, {
                    input: input,
                    index: index
                })
            }, input.uid);
        });
    }, [
        qryInputs
    ]);
    var headerText = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (qryInputs.length === 0) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "d-flex flex-1 mr-auto",
                children: toMainPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: "",
                    color: "secondary",
                    onClick: toMainPage,
                    title: t("Go to main page to add input files"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_8__/* .BsChevronLeft */ .pjk, {
                            className: "mr-1"
                        }),
                        t("Add data")
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "d-flex mt-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    children: t("Sequence data you've added")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "d-flex ml-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: "",
                            color: "link",
                            onClick: clearQryInputs,
                            title: t("Remove all input files"),
                            children: t("Remove all")
                        }),
                        toMainPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: "",
                            color: "secondary",
                            onClick: toMainPage,
                            title: t("Go to main page to add more input files"),
                            children: t("Add more")
                        })
                    ]
                })
            ]
        });
    }, [
        clearQryInputs,
        qryInputs.length,
        t,
        toMainPage
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContainerMain, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: headerText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Ul, {
                children: listItems
            })
        ]
    });
}
var ContainerMain = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-70d2c1bb-0"
})(_templateObject());
var Ul = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(src_components_Common_List__WEBPACK_IMPORTED_MODULE_3__/* .UlGeneric */ .w7).withConfig({
    componentId: "sc-70d2c1bb-1"
})(_templateObject1());
var Li = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-70d2c1bb-2"
})(_templateObject2());
var InputNameWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-70d2c1bb-3"
})(_templateObject3());
var InputName = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-70d2c1bb-4"
})(_templateObject4());
function InputFileInfo(param) {
    var input = param.input, index = param.index;
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_4__/* .useTranslationSafe */ ._)().t;
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .useTheme */ .Fg)();
    var removeQryInput = (0,src_state_inputs_state__WEBPACK_IMPORTED_MODULE_5__/* .useQuerySeqInputs */ .HT)().removeQryInput;
    var onRemoveClicked = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        removeQryInput(index);
    }, [
        index,
        removeQryInput
    ]);
    var icon = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        switch(input.type){
            case src_types__WEBPACK_IMPORTED_MODULE_6__/* .AlgorithmInputType.File */ .$Z.File:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ci__WEBPACK_IMPORTED_MODULE_10__/* .CiFileOn */ .TxY, {
                        size: 20,
                        className: "mt-1"
                    });
                }
            case src_types__WEBPACK_IMPORTED_MODULE_6__/* .AlgorithmInputType.Url */ .$Z.Url:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ci__WEBPACK_IMPORTED_MODULE_10__/* .CiLink */ .dmD, {
                        size: 20,
                        className: "mt-1"
                    });
                }
            case src_types__WEBPACK_IMPORTED_MODULE_6__/* .AlgorithmInputType.String */ .$Z.String:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ci__WEBPACK_IMPORTED_MODULE_10__/* .CiTextAlignJustify */ .kkL, {
                        size: 20,
                        className: "mt-1"
                    });
                }
            case src_types__WEBPACK_IMPORTED_MODULE_6__/* .AlgorithmInputType.Default */ .$Z.Default:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ci__WEBPACK_IMPORTED_MODULE_10__/* .CiStar */ .Q$h, {
                        size: 20,
                        className: "mt-1"
                    });
                }
            default:
                return null;
        }
    }, [
        input.type
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputIconWrapper, {
                children: icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputNameWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputName, {
                    title: input.description,
                    children: input.description
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_ButtonTransparent__WEBPACK_IMPORTED_MODULE_2__/* .ButtonTransparent */ .h, {
                className: "ml-auto",
                title: t(" Remove this input"),
                onClick: onRemoveClicked,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_11__/* .MdClear */ .lUB, {
                    color: theme.gray500
                })
            })
        ]
    });
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-70d2c1bb-5"
})(_templateObject5());
var InputIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-70d2c1bb-6"
})(_templateObject6());


/***/ }),

/***/ 52222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ SuggestionError; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60822);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31382);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86000);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16130);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37536);
/* harmony import */ var src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87181);
/* harmony import */ var src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69068);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  padding: 0.75rem 1rem;\n  width: 100%;\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function SuggestionError(_param) {
    var restProps = _extends({}, _param);
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_4__/* .useTranslationSafe */ ._)().t;
    var autodetectError = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_5__/* .autodetectErrorAtom */ .eY);
    if ((0,lodash__WEBPACK_IMPORTED_MODULE_2__.isNil)(autodetectError)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Alert, _objectSpread({
        closeClassName: "d-none",
        fade: false,
        color: "danger"
    }, restProps, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                className: "font-weight-bold",
                children: t("Suggestion algorithm failed.")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: autodetectError.message
            })
        ]
    }));
}
var Alert = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f3b67104-0"
})(_templateObject());


/***/ }),

/***/ 73234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xi": function() { return /* binding */ ButtonSuggest; },
/* harmony export */   "wP": function() { return /* binding */ SuggestionPanel; }
/* harmony export */ });
/* unused harmony exports ButtonSuggestionsReset, FlexLeft, FlexRight, AutosuggestionToggle */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31382);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60822);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32373);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67693);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21602);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(16082);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16130);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(37536);
/* harmony import */ var src_components_Common_Toggle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74982);
/* harmony import */ var src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87181);
/* harmony import */ var src_hooks_useResetSuggestions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33300);
/* harmony import */ var src_hooks_useRunSeqAutodetect__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33035);
/* harmony import */ var src_hooks_useToggle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83144);
/* harmony import */ var src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69068);
/* harmony import */ var src_state_dataset_state__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99902);
/* harmony import */ var src_state_inputs_state__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67821);
/* harmony import */ var src_state_settings_state__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99664);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  min-height: 38px;\n  padding: 0 5px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  margin-right: auto;\n  vertical-align: middle;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 140px;\n  height: 38px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 1rem;\n  max-width: 100px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin: auto 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}















function SuggestionPanel() {
    var minimizerIndexVersion = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(src_state_dataset_state__WEBPACK_IMPORTED_MODULE_10__/* .minimizerIndexVersionAtom */ .gL);
    if ((0,lodash__WEBPACK_IMPORTED_MODULE_1__.isNil)(minimizerIndexVersion)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Form, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlexLeft, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AutosuggestionToggle, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FlexRight, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonSuggestionsReset, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonSuggest, {})
                    ]
                })
            ]
        })
    });
}
function ButtonSuggest() {
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_5__/* .useTranslationSafe */ ._)().t;
    var hasRequiredInputs = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(src_state_inputs_state__WEBPACK_IMPORTED_MODULE_11__/* .hasRequiredInputsAtom */ .ZX);
    var runSuggest = (0,src_hooks_useRunSeqAutodetect__WEBPACK_IMPORTED_MODULE_7__/* .useRunSeqAutodetect */ .oh)({
        shouldSetCurrentDataset: true
    });
    var hasAutodetectResults = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_9__/* .hasAutodetectResultsAtom */ .KR);
    var autodetectRunState = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_9__/* .autodetectRunStateAtom */ .dZ);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var canRun = hasRequiredInputs;
        var isRunning = autodetectRunState === src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_9__/* .AutodetectRunState.Started */ .vj.Started;
        return {
            text: isRunning ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        size: "sm"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "ml-2",
                        children: t("Suggesting")
                    })
                ]
            }) : hasAutodetectResults ? t("Re-suggest") : t("Suggest"),
            disabled: !canRun || isRunning,
            color: !canRun ? "secondary" : "primary",
            title: isRunning ? t("Running") : !canRun ? t("Please provide sequence data for the algorithm") : hasAutodetectResults ? t("Re-launch suggestions engine!") : t("Launch suggestions engine!")
        };
    }, [
        autodetectRunState,
        hasAutodetectResults,
        hasRequiredInputs,
        t
    ]), text = ref.text, disabled = ref.disabled, color = ref.color, title = ref.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonRunStyled, {
        onClick: runSuggest,
        disabled: disabled,
        color: color,
        title: title,
        children: text
    });
}
function ButtonSuggestionsReset() {
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_5__/* .useTranslationSafe */ ._)().t;
    var resetAutodetectResults = (0,src_hooks_useResetSuggestions__WEBPACK_IMPORTED_MODULE_6__/* .useResetSuggestionsAndDatasets */ .Y)();
    var hasAutodetectResults = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_9__/* .hasAutodetectResultsAtom */ .KR);
    var hasTopSuggestedDatasets = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_9__/* .hasTopSuggestedDatasetsAtom */ .Ql);
    var isAutodetectRunning = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(src_state_autodetect_state__WEBPACK_IMPORTED_MODULE_9__/* .isAutodetectRunningAtom */ .Kt);
    var disabled = isAutodetectRunning || !(hasAutodetectResults && hasTopSuggestedDatasets);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonResetStyled, {
        color: "link",
        onClick: resetAutodetectResults,
        disabled: disabled,
        children: t("Reset")
    });
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2ff2834-0"
})(_templateObject());
var Form = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2ff2834-1"
})(_templateObject1());
var FlexLeft = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2ff2834-2"
})(_templateObject2());
var FlexRight = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2ff2834-3"
})(_templateObject3());
var ButtonRunStyled = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2ff2834-4"
})(_templateObject4());
var ButtonResetStyled = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2ff2834-5"
})(_templateObject5());
function AutosuggestionToggle(_param) {
    var restProps = _extends({}, _param);
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_5__/* .useTranslationSafe */ ._)().t;
    var ref = (0,src_hooks_useToggle__WEBPACK_IMPORTED_MODULE_8__/* .useRecoilToggle */ .T)(src_state_settings_state__WEBPACK_IMPORTED_MODULE_12__/* .shouldSuggestDatasetsOnDatasetPageAtom */ .Ji), shouldSuggestDatasets = ref.state, toggleSuggestDatasets = ref.toggle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormGroup, _objectSpread({}, restProps, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_Toggle__WEBPACK_IMPORTED_MODULE_4__/* .Toggle */ .Z, {
            identifier: "toggle-suggest-datasets",
            checked: shouldSuggestDatasets,
            onCheckedChanged: toggleSuggestDatasets,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "my-auto",
                title: t("Enable suggestion of best matching pathogen datasets. Please add sequence data to launch suggestion engine."),
                children: t("Suggest automatically")
            })
        })
    }));
}
var FormGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2ff2834-6"
})(_templateObject6());


/***/ })

}]);